export function sanitizePublicAiMessage(message: string): string {
  return message
    .replace(/\*\*([^*\n][^*\n]*?)\*\*/g, '$1')
    .replace(/__([^_\n][^_\n]*?)__/g, '$1');
}

export function publicAiMessageParagraphs(message: string): string[] {
  return sanitizePublicAiMessage(message)
    .split(/\n{2,}/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean);
}
